import { useState, useEffect, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import { Tooltip } from "react-tooltip";
import "./style.css";
import { ReactComponent as MenuIcon } from "../../Assets/images/menuIcon.svg";
import { ReactComponent as BellIcon } from "../../Assets/images/bellIcon.svg";
import { ReactComponent as Close } from "../../Assets/images/close.svg";
import { ReactComponent as KeyboardIcon } from "../../Assets/icon/keyboard.svg";
import { ReactComponent as VoiceBars } from "../../Assets/icon/voice-bars.svg";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { signOut } from "../../Services/auth";
import { getUnreadNotificationCount } from "../../Services/notificationAris";
import NotificationContainer from "../NotificationContainer/NotificationContainer";
import ReferralPopup from "../../Pages/ReferralPopup";
import ChatModal from "../ChatModal/ChatModal";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { useFCMNotifications } from "../../Contexts/FCMNotificationContext";
import MenuComponent from "./MenuComponent";
import Loader from "react-js-loader";
import SessionSelection from "../../Pages/RelationShip/LiveSession/SessionSelection";
import GroupMemberSelectionModal from "../../Pages/RelationShip/LiveSession/modals/session/GroupMemberSelectionModal";
import { updateCoachingMode, getCoachingMode } from "../../Services/userSettings";
import { getUserProfile } from "../../Services/MyProfile";
import GenericModal from "../Modal/GenericModal";

function CircularImage({ }) {
  const { profileContent } = useHeader();

  return (
    <CircularProgressbarWithChildren
      value={profileContent?.profile_completion_percent || 0}
      strokeWidth={8}
      className={`header-progress`}
      styles={buildStyles({
        strokeLinecap: "butt",
        pathColor: " #BCF5A7",
        textColor: "#f88",
        trailColor: "#274079",
        backgroundColor: "#3e98c7",
      })}
    >
      <div>
        {profileContent?.profile_pic_url ? (
          <img
            src={profileContent?.profile_pic_url}
            alt="Circular"
            width={32}
            height={32}
            className="circular-image"
          />
        ) : (
          <div
            className="header-profile-circle-image"
            style={{ width: "2.50 rem", height: "2.50 rem" }}
          >
            {`${profileContent?.first_name?.[0]?.toUpperCase() || ""}${profileContent?.last_name?.[0]?.toUpperCase() || ""
              }`}
          </div>
        )}
      </div>
    </CircularProgressbarWithChildren>
  );
}

const aboutAris = () => {
  window.location.href = "/about-aris";
};
const termOfUse = () => {
  window.location.href = "/term-of-use";
};
const privacyPolicy = () => {
  window.location.href = "/privacy-policy";
};

const handleNavigate = () => {
  window.location.href = "/dashboard";
};

const handleNavigateMyRelationship = () => {
  window.location.href = "/manageRelationship";
};

const onboarding = () => {
  window.location.href = "/customer-support";
};

const gotoManageMembership = () => {
  window.location.href = "/manageMembership";
};

const onboardingfunc = () => {
  onboarding();
};

const MyRelationshipfunc = async () => {
  handleNavigateMyRelationship();
};

function HeaderComponent({ isCoachingActive }) {
  const {
    headerContentRightSideContent,
    profileContent,
    isChatHistoryOpen,
  } = useHeader();
  
  const [showMenu, setShowMenu] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [showKeyboardSwitch, setShowKeyboardSwitch] = useState(false);
  const [showVoiceSwitch, setShowVoiceSwitch] = useState(false);
  const [showHeaderLogo, setShowHeaderLogo] = useState(true);
  const [showKeyboardSwitchModal, setShowKeyboardSwitchModal] = useState(false);

  // Partner dialogue modal state - moved to parent to persist when menu closes
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [coupleCoaching, setCoupleCoaching] = useState(false);

  const calendarRef = useRef(null);
  const notificationRef = useRef(null);
  const intervalRef = useRef(null);

  // FCM integration via context
  const { onMessageReceived, onNotificationClicked, isInitialized, incrementNotificationCount } = useFCMNotifications();

  const fetchUnreadCount = async (force = false) => {
    try {
      // Guard by route for polling; but allow forced refresh from events
      if (!force && !isNotificationRoute()) {
        return;
      }
      const count = await getUnreadNotificationCount();
      setNotificationCount(count || 0);
    } catch (e) {
      setNotificationCount(0);
      console.error("Error fetching unread notification count:", e);
    }
  };

  const isNotificationRoute = () => {
    try {
      const pathname = window?.location?.pathname || "";
      return ["/chat", "/dashboard", "/dialogues"].some((p) => pathname.startsWith(p));
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    // Start interval on mount; each tick checks route guard before calling API
    const intervalMs = Number(process.env.REACT_APP_NOTIFICATION_INTERVAL) || 3600000;
    // Immediate attempt (will no-op if route not allowed)
    fetchUnreadCount();
    intervalRef.current = setInterval(fetchUnreadCount, intervalMs);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  // Listen to FCM events to update bell count immediately via context
  useEffect(() => {
    if (!isInitialized) return;

    // On message received in foreground, optimistically increment and refresh
    const unSubMsg = onMessageReceived(() => {
      setNotificationCount((c) => (typeof c === "number" ? c + 1 : 1));
      // Refresh from server shortly after to stay accurate
      setTimeout(() => fetchUnreadCount(true), 1000);
    });

    // On notification clicked, refresh count (it might mark as read)
    const unSubClick = onNotificationClicked(() => {
      setTimeout(() => fetchUnreadCount(true), 500);
    });

    return () => {
      unSubMsg();
      unSubClick();
    };
  }, [isInitialized, onMessageReceived, onNotificationClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setError("");
    }, 3000);
  }, [error]);

  useEffect(() => {
    const updateLayoutFlags = () => {
      try {
        const mode = getCoachingMode();
        const isVoice = mode === "voice";
        setShowKeyboardSwitch(isVoice);
        setShowVoiceSwitch(!isVoice);
        const isMobile = window.innerWidth <= 440;
        setIsMobileView(isMobile);
      } catch (_) {
        setShowKeyboardSwitch(false);
        setShowVoiceSwitch(false);
      }
    };

    updateLayoutFlags();
    window.addEventListener("resize", updateLayoutFlags);
    return () => window.removeEventListener("resize", updateLayoutFlags);
  }, []);

  // Separate effect to handle header visibility based on coaching session state
  useEffect(() => {
    const pathname = window?.location?.pathname || "";
    const isCoachRoute = pathname.startsWith("/coach");
    const mode = getCoachingMode();
    const isVoice = mode === "voice";
    
    // Hide header when on coach route AND session is active (for all screen sizes)
    if (isVoice && isCoachRoute && isCoachingActive) {
      setShowHeaderLogo(false);
    } else {
      setShowHeaderLogo(true);
    }
  }, [isCoachingActive]);

  // Hide header for admin routes - check AFTER all hooks
  const pathname = window?.location?.pathname || "";
  if (pathname.startsWith("/admin")) {
    return null;
  }

  const closeMenu = (e) => {
    e.stopPropagation();
    setShowMenu(false);
  };

  const sideMenuHandle = () => {
    setShowNotification(false);
    setShowCalendar(false);
    setShowMenu((prev) => !prev);
  };

  const handleHeaderKeyboardSwitch = () => {
    // If coaching session is active, show confirmation modal
    if (isCoachingActive) {
      setShowKeyboardSwitchModal(true);
    } else {
      // Direct switch if no active session
      handleDirectSwitchToKeyboard();
    }
  };

  const handleDirectSwitchToKeyboard = async () => {
    try {
      await updateCoachingMode("keyboard");
      try {
        const updatedProfile = await getUserProfile();
        localStorage.setItem("profile", JSON.stringify(updatedProfile));
      } catch (profileError) {
        console.error("Failed to refetch profile:", profileError);
        try {
          const profileData = JSON.parse(localStorage.getItem("profile") || "{}");
          if (profileData.meta_info && profileData.meta_info.settings) {
            profileData.meta_info.settings.coaching_mode = "keyboard";
          } else {
            if (!profileData.meta_info) profileData.meta_info = {};
            if (!profileData.meta_info.settings) profileData.meta_info.settings = {};
            profileData.meta_info.settings.coaching_mode = "keyboard";
          }
          profileData.coaching_mode = "keyboard";
          localStorage.setItem("profile", JSON.stringify(profileData));
        } catch (_) { }
      }
    } catch (_) { }

    window.location.href = "/dashboard";
  };

  const handleHeaderVoiceSwitch = async () => {
    try {
      await updateCoachingMode("voice");
      localStorage.setItem("coaching_mode", "voice");
      try {
        const updatedProfile = await getUserProfile();
        localStorage.setItem("profile", JSON.stringify(updatedProfile));
      } catch (profileError) {
        console.error("Failed to refetch profile:", profileError);
        try {
          const profileData = JSON.parse(localStorage.getItem("profile") || "{}");
          if (profileData.meta_info && profileData.meta_info.settings) {
            profileData.meta_info.settings.coaching_mode = "voice";
          } else {
            if (!profileData.meta_info) profileData.meta_info = {};
            if (!profileData.meta_info.settings) profileData.meta_info.settings = {};
            profileData.meta_info.settings.coaching_mode = "voice";
          }
          profileData.coaching_mode = "voice";
          localStorage.setItem("profile", JSON.stringify(profileData));
        } catch (_) { }
      }
    } catch (_) { }
    window.location.href = "/dashboard";
  };

  const signOutFunction = async () => {
    setLoading(true);
    await signOut()
      .then(() => {
        handleNavigate();
      })
      .catch((err) => {
        setError("Something went wrong please try again");
      })
      .finally(() => setLoading(false));
  };

  // Hide entire header when coaching session is active on coach route
  if (!showHeaderLogo) {
    return null;
  }

  return (
    <div className="header-component-hero-container">
      <ChatModal
        onClose={() => setShowLogoutPopup(false)}
        width={"300px"}
        height={"auto"}
        padding={"0px"}
        isOpen={showLogoutPopup}
        // isOpen={true}
        children={
          <div>
            <div className="logout-modal-container">
              <div className="logout-modal-header">Log Out</div>
              {loading && (
                <div className="loader-df-container">
                  <Loader
                    type="spinner-cub"
                    bgColor={"#2D50A7"}
                    color={"#3D6DEB"}
                    // title={"spinner-cub"}
                    size={45}
                  />
                </div>
              )}
              <div className="logout-modal-body">
                Are you sure you want to log out?
              </div>
            </div>
            {error && (
              <div style={{ color: "red", width: "100%", textAlign: "center" }}>
                {error}
              </div>
            )}
            <div className="logout-modal-button-container">
              <div
                className={`logout-cancel ${loading && "disabled-button"}`}
                onClick={() => setShowLogoutPopup(false)}
              >
                Cancel
              </div>
              <div
                className={`logout-cancel logout-btn ${loading && "disabled-button"
                  }`}
                onClick={signOutFunction}
              >
                Log out
              </div>
            </div>
          </div>
        }
      />
      <div className="header-component-left-container">
        <div 
          className="header-menu-icon-container" 
          onClick={isCoachingActive ? undefined : sideMenuHandle}
          style={{ opacity: isCoachingActive ? 0.5 : 1, cursor: isCoachingActive ? 'not-allowed' : 'pointer' }}
        >
          {!showMenu ? <MenuIcon /> : <Close />}
          {showMenu && (
            <MenuComponent
              closeMenu={closeMenu}
              // close={() => {
              //   setShowNotification(false);
              //   setShowMenu((prev) => !prev);
              // }}
              hideRelationShipManager={window?.location?.href?.includes(
                "onboarding"
              )}
              setShowPopup={setShowPopup}
              setShowLogoutPopup={setShowLogoutPopup}
              isGroupModalOpen={isGroupModalOpen}
              setIsGroupModalOpen={setIsGroupModalOpen}
              coupleCoaching={coupleCoaching}
              setCoupleCoaching={setCoupleCoaching}
            />
          )}
        </div>
      </div>

      {headerContentRightSideContent ? (
        <div className="header-notification-container">
          {/* <div
            className="header-menu-icon-container-notification bell-icon-container"
            onClick={() => {
              setShowCalendar(!showCalendar);
              setShowMenu(false);
              setShowNotification(false);
            }}
          >
            <Calendar />
          </div>
          {showCalendar && (
            <div ref={calendarRef}>
              <ScheduleContainer
                setshowCalendar={setShowCalendar}
                setShowRescheduleModal={setShowRescheduleModal}
                setSelectedSessionId={setSelectedSessionId}
              />
            </div>
          )} */}

          {!isChatHistoryOpen && (
            <>
              {showKeyboardSwitch && (
                <div
                  className="coaching-button-container keyboard-switch-btn tooltip-container"
                  onClick={handleHeaderKeyboardSwitch}
                  data-tooltip-id="header-keyboard-switch-tip"
                  data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
                    <div>Switch to chat home</div>
                  )}
                >
                  <KeyboardIcon className="mic-icon" />
                  <Tooltip
                    id="header-keyboard-switch-tip"
                    place="bottom"
                    className="aris-tooltip"
                  />
                </div>
              )}
              {showVoiceSwitch && (
                <div
                  className="coaching-button-container voice-switch-btn tooltip-container"
                  onClick={handleHeaderVoiceSwitch}
                  data-tooltip-id="header-voice-switch-tip"
                  data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
                    <div>Switch to voice home</div>
                  )}
                >
                  <VoiceBars className="mic-icon" />
                  <Tooltip
                    id="header-voice-switch-tip"
                    place="bottom"
                    className="aris-tooltip"
                  />
                </div>
              )}
              <div
                className="header-menu-icon-container-notification bell-icon-container"
                onClick={isCoachingActive ? undefined : () => {
                  setShowMenu(false);
                  setShowCalendar(false);
                  setShowNotification((prev) => !prev);
                }}
                style={{ opacity: isCoachingActive ? 0.5 : 1, cursor: isCoachingActive ? 'not-allowed' : 'pointer' }}
              >
                <BellIcon />
                {notificationCount > 0 && (
                  <div className="notification-badge">{notificationCount}</div>
                )}
              </div>
            </>
          )}
          {showNotification && (
            <div ref={notificationRef}>
              <NotificationContainer
                onRouted={() => setShowNotification(false)}
                setshowNotification={setShowNotification}
                showNotification={showNotification}
                refreshUnreadCount={fetchUnreadCount}
              />
            </div>
          )}
        </div>
      ) : (
        <div></div>
      )}

      {showPopup && <ReferralPopup onClose={() => setShowPopup(false)} />}
      {showRescheduleModal && (
        <SessionSelection
          showLiveSessionModal={showRescheduleModal}
          setShowLiveSessionModal={setShowRescheduleModal}
          onClose={() => {
            setShowRescheduleModal(false);
            setSelectedSessionId(null);
          }}
          setShowCalendar={setShowCalendar}
          isReschedule={true}
          sessionId={selectedSessionId}
        />
      )}
      
      {/* Partner Dialogue Modal - rendered at header level to persist when menu closes */}
      {isGroupModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '476px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3>Select Relationship</h3>
              <button 
                onClick={() => setIsGroupModalOpen(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
            </div>
            <GroupMemberSelectionModal
              onClose={() => setIsGroupModalOpen(false)}
              hideCloseIcon={true}
              coupleCoaching={coupleCoaching}
            />
          </div>
        </div>
      )}

      {/* Switch to Keyboard Mode modal */}
      <GenericModal
        isOpen={showKeyboardSwitchModal}
        onClose={() => setShowKeyboardSwitchModal(false)}
        heading="Switch to Keyboard Mode?"
        primaryLabel="Switch"
        secondaryLabel="Cancel"
        onPrimary={async () => {
          try {
            await updateCoachingMode('keyboard');
            localStorage.setItem('coaching_mode', 'keyboard');
            try {
              const updatedProfile = await getUserProfile();
              localStorage.setItem('profile', JSON.stringify(updatedProfile));
            } catch (profileError) {
              console.error('Failed to refetch profile:', profileError);
              try {
                const profileData = JSON.parse(localStorage.getItem('profile') || '{}');
                if (profileData.meta_info && profileData.meta_info.settings) {
                  profileData.meta_info.settings.coaching_mode = 'keyboard';
                } else {
                  if (!profileData.meta_info) profileData.meta_info = {};
                  if (!profileData.meta_info.settings) profileData.meta_info.settings = {};
                  profileData.meta_info.settings.coaching_mode = 'keyboard';
                }
                profileData.coaching_mode = 'keyboard';
                localStorage.setItem('profile', JSON.stringify(profileData));
              } catch (_) { }
            }
          } catch (_) { }
          setShowKeyboardSwitchModal(false);
          window.location.href = '/dashboard';
        }}
        onSecondary={() => setShowKeyboardSwitchModal(false)}
        maxWidth="548px"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={{ margin: 0 }}>
            By switching you will start a new chat, but Aris will remember everything you talked about.
          </p>
        </div>
      </GenericModal>
    </div>
  );
}

export default HeaderComponent;
